<script setup lang="ts">
import type { Image } from 'sanity';
import { computed, type Component } from 'vue';
import type { SurpriseBagTranslations, BagNotFoundCopy } from '@pkg/types/surpriseBag';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    preTitle?: string,
    title: string,
    placeholder?: string,
    image: Image,
    is404?: boolean,
    resultsTitle?: string,
    noLocationText?: string,
    useMyLocationLabel?: string,
    dontUseMyLocationLabel?: string,
    loadingMyLocationLabel?: string,
    bagNotFoundCopy?: BagNotFoundCopy,
    geolocationErrorLabel?: string,
    myLocationLabel?: string,
    ctaText?: string,
    noFilterLabel?: string,
    availableBagsFilterLabel?: string,
    emptyStateText?: string,
    errorStateText?: string,
    staticTranslations: SurpriseBagTranslations,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  preTitle: props.block?.preTitle,
  title: props.block?.title,
  placeholder: props.block?.placeholder,
  image: props.block?.image,
  is404: props.block?.is404,
  resultsTitle: props.block?.resultsTitle,
  noLocationText: props.block?.noLocationText,
  useMyLocationLabel: props.block?.useMyLocationLabel,
  dontUseMyLocationLabel: props.block?.dontUseMyLocationLabel,
  loadingMyLocationLabel: props.block?.loadingMyLocationLabel,
  geolocationErrorLabel: props.block?.geolocationErrorLabel,
  myLocationLabel: props.block?.myLocationLabel,
  ctaText: props.block?.ctaText,
  noFilterLabel: props.block?.noFilterLabel,
  availableBagsFilterLabel: props.block?.availableBagsFilterLabel,
  emptyStateText: props.block?.emptyStateText,
  errorStateText: props.block?.errorStateText,
  staticTranslations: props.block?.staticTranslations,
  bagNotFoundCopy: props.block?.bagNotFoundCopy,
}));

</script>

<template>
    <component :is="props.config?.innerComponent" v-bind="data" />
</template>